import { getFunctions, httpsCallable } from "firebase/functions";
import { log } from "../../helper/helper";
import config from "./../../config.json";
import { getApp } from "firebase/app";

export function adminGetReservedOrdersListApiIntegration(customerUserId) {
  let data = {}
  if (customerUserId !== "") {
    data.customer_user_id = customerUserId
  }
  log(data)
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const allTransports = httpsCallable(
    functions,
    config.adminGetReservedOrdersListApiIntegration
  );
  return allTransports(data);
}
